import React from "react";
import { QRCodeCanvas } from "qrcode.react";

interface QrCodeProps {
  url: string;
  size?: number;      // tùy chọn: kích thước QR
  bgColor?: string;   // tùy chọn: màu nền
  fgColor?: string;   // tùy chọn: màu QR
}

const QrCode: React.FC<QrCodeProps> = ({
  url,
  size = 200,
  bgColor = "#ffffff",
  fgColor = "#000000",
}) => {
  return (
      <QRCodeCanvas 
        value={url}
        size={size}
        bgColor={bgColor}
        fgColor={fgColor}
        level="H"
        includeMargin={true}
      />
  );
};

export default QrCode;
